<template>
    <v-flex sm8 offset-sm2>

        <v-card>
            <v-toolbar color="#CEE2DC" dense>
                <v-toolbar-title>Current Content</v-toolbar-title>
            </v-toolbar>      

            <v-container>
                <v-row>
                    <v-col cols="2">
                        <!-- <v-sheet color="#CEE2DC" dark>Text color</v-sheet> -->
                        <v-text-field readonly outlined placeholder=" " dense :background-color=$store.state.remoteText_color></v-text-field>
                    </v-col>
                    <v-col cols="10">
                        <v-text-field readonly outlined v-model=$store.state.remoteText dense></v-text-field> 
                    </v-col>
                </v-row>
            </v-container>
        </v-card>

        <br>

        <v-card>
            <v-toolbar color="#CEE2DC" dense>
                <v-toolbar-title>Change Content</v-toolbar-title>
            </v-toolbar>      

            <v-form ref="form" class="d-flex flex-column">
                <v-row class="d-flex px-3">
                    <v-col class="ma-2 flex-grow-0">
                        <compact-picker v-model="colors" @input="updateValue" 
                            :palette="[ 
                                '#FF0000', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#68BC00', 
                                '#00FF00', '#0000FF', '#009CE0', '#7B64FF', '#FA28FF', '#C45100', '#FB9E00', '#808900', '#0C797D', '#AB149E'
                            ]" >
                        </compact-picker>
                    </v-col>
                    <v-col class="ma-2 flex-grow-1 flex-shrink-0">
                        <v-text-field v-model="newText" class="ma-1" outlined placeholder="Type in the new text for the remote device." dense></v-text-field> 
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="flex-grow-1 text-right">
                        <v-btn class="mx-3 pr-3" @click="updateContent" color="#CEE2DC">Update</v-btn> 
                        <v-btn class="mx-6" @click="clearForm" color="#CEE2DC">Cancel</v-btn> 
                    </v-col>
                </v-row>
            </v-form>

        </v-card>
    </v-flex>
</template>



<script>

import VueColor from 'vue-color'

let colors = {
    hex: '#00FF00',
};


export default {
    components: { 
        'compact-picker': VueColor.Compact, 
    },
    
    data() {
        return {
            colors,
            newText: '',
        };
    },
    async created() {
        this.$store.dispatch('getRemoteContent');
    },

    computed: {
        bgc () {
            return this.colors.hex
        }
    },

    methods: {

        updateValue (value) {   // called when user clicks on color picker
            this.colors = value
            console.log("selected color: " + this.colors.hex);
        },

        updateContent() {
            this.$store.dispatch('setRemoteContent', { color: this.colors.hex, text: this.newText }).then(() => {
                this.$refs.form.reset();
            }, e => {
                console.log(e);
                this.$toasted.error('Error updating [server] content!', 
                    { theme: "toasted-primary", icon: 'alert-circle-outline', position: "top-center", duration : 2400 })
            });
        },

        clearForm() {
            this.$refs.form.reset();
        }
    },

};
</script>